import { GET_PRODUCT, SET_LOADING, CLEAR_LOADING } from '../types'

export const setLoading = () => ({
  type: SET_LOADING
})

export const clearLoading = () => ({
  type: CLEAR_LOADING
})

export const setProduct = (result) => ({
  type: GET_PRODUCT,
  payload: result
})
